import { cx } from 'cva';
import {
  Label as RACLabel,
  type LabelProps as RACLabelProps,
} from 'react-aria-components/Label';

import styles from './slider.module.css';

export type LabelProps = RACLabelProps;

export function SliderLabel(props: LabelProps) {
  const { className, ...rest } = props;
  const classes = cx(styles.slider_label, className);
  return <RACLabel className={classes} {...rest} />;
}
